<template>
    <div class="container">
        <span>销售品项统计</span>
        <div class="search-box">
            <span style=" font-size: 14px;margin-right: 10px;">统计周期:</span>
            <div class="type-box">
                <span :class="type === 'day' ? 'active' : ''" @click="changeDate('day')"> 按日</span>
                <span :class="type === 'monthrange' ? 'active' : ''" @click="changeDate('monthrange')"> 按月</span>
                <span :class="type === 'daterange' ? 'active' : ''" @click="changeDate('daterange')">自定义</span>
            </div>
            <span style=" font-size: 14px;margin-right: 10px;">营业周期:</span>
            <el-date-picker v-model="dataTime" :type="type === 'day' ? 'daterange' : type" :format="format"
                :placeholder="placeholder" :picker-options="pickerOptions">
            </el-date-picker>
            <el-button type="primary" icon="el-icon-search"
                style="margin-left: 20px;background-color: #f59a23;border: none;" @click="search">查询</el-button>
            <el-button icon="el-icon-refresh" style="margin-left: 20px;" @click="reset">重置</el-button>
        </div>
        <!-- echarts 圆环饼图 -->
        <div id="pieChart" style="width: 100%;height: 400px;margin: 20px;">

        </div>
        <el-table element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 0.3)" :data="tableData" style="width: 98%" border
            v-loading="loading" :summary-method="getSummaries" show-summary>
            <el-table-column type="index" width="100" label="序号" align="center">
            </el-table-column>
            <el-table-column prop="orderTime" label="点单时间" align="center"></el-table-column>
            <el-table-column prop="payPrice" label="支付价格" align="center"></el-table-column>
            <el-table-column prop="sumPrice" label="总价" align="center"></el-table-column>
            <el-table-column prop="num" label="数量" align="center"></el-table-column>
            <el-table-column prop="normalPrice" label="正常单价" align="center"></el-table-column>
            <el-table-column prop="productPrice" label="产品单价" align="center"></el-table-column>


        </el-table>
        <!--  <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.currPage" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next" :total="total">
            </el-pagination>
        </div> -->
    </div>
</template>

<script>
import * as echarts from 'echarts'
import moment from 'moment/moment';
// 创建一个表示当前日期的 Date 对象
let currentDate = new Date();

// 获取当前日期的天数
let currentDay = currentDate.getDate();

// 将日期减去一天
currentDate.setDate(currentDay - 1);
export default {
    name: '',
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return time.getTime() >= today.getTime();
                }
            },
            type: 'monthrange',
            dataTime: [currentDate, currentDate],
            format: 'yyyy/MM',
            vformat: 'yyyy/MM',
            placeholder: '选择月',
            active: 0,
            dateTime: [],
            tableData: [],
            queryInfo: {
                condition: {
                },
                currPage: 1,
                pageCount: 1,
                pageSize: 10,
            },
            options: [],
            areaOptions: [],
            total: 0,
            loading: false
        };
    },
    mounted() {
        this.getData()
    },
    methods: {
        search() {
            this.getData()
        },
        reset() {
            //moment.js 格式化时间
            this.dataTime = [currentDate, currentDate]
            this.getData()
        },
        changeDate(type) {
            //moment.js 格式化时间
            this.dataTime = [currentDate, currentDate]
            if (type === 'day') {
                this.format = 'yyyy-MM-dd';
                this.vformat = 'YYYY-MM-DD';
                this.placeholder = '选择月';
            } else if (type === 'monthrange') {
                this.format = 'yyyy/MM';
                this.vformat = 'YYYY/MM';
                this.placeholder = '选择月';
            } else if (type === 'daterange') {
                this.format = 'yyyy-MM-dd';
                this.vformat = 'YYYY-MM-DD';
                this.placeholder = '选择日期范围';
            }
            this.type = type;
        },
        // 获取当前页面
        handleCurrentChange(val) {
            this.queryInfo.currPage = val;
            this.getData();
        },
        // 修改页数大小
        handleSizeChange(val) {
            this.queryInfo.pageSize = val;
            this.getData();
        },
        //初始化饼图
        initPieChart(value) {
            let pieChart = echarts.init(document.getElementById('pieChart'));
            let option = {
                title: {
                    show: true,
                    text: '营业收入\n\n' + value, //图中间的值
                    x: 'center', //居中
                    y: '36%',
                    textStyle: {
                        fontSize: '14',
                        color: '#666'
                    }
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    icon: 'circle',
                    bottom: 10,
                },
                label: {
                    show: true,
                    position: 'center',
                    formatter: '{b}: {c}', // 显示文本，{b} 是名称，{c} 是值

                },
                itemStyle: {
                    color: '#FED203' // 设置圆环的颜色
                },
                series: [
                    {
                        name: '菜品销售',
                        type: 'pie',
                        center: ['50%', '45%'], // 设置圆环的中心位置
                        radius: ['50%', '70%'], // 设置圆环的内外半径
                        data: [{
                            value: value,
                            name: '菜品销售'
                        }]
                    }
                ]

            }

            pieChart.setOption(option);
            window.addEventListener('resize', () => {
                pieChart.resize()
            })
        },
        async getData() {
            let params = {
                code: localStorage.getItem('merchantCode'),
            }
            let timeType = 0
            let startTime = null
            let endTime = null
            let time = null
            let timeTwo = null
            let type = 0
            if (this.type === 'day') {
                type = 1
                if (this.dataTime != null && this.dataTime.length > 0) {
                    time = moment(this.dataTime[0]).format(this.vformat)
                    timeTwo = moment(this.dataTime[1]).format(this.vformat)
                } else {
                    this.$message.error('请选择时间范围')
                    return
                }
                params.startTime = time
                params.endTime = timeTwo
                params.timeType = 6
                params.type = type
            } else {
                timeType = this.type === 'monthrange' ? 3 : 6
                if (timeType == 6) {
                    if (this.dataTime != null && this.dataTime.length > 0) {
                        startTime = moment(this.dataTime[0]).format(this.vformat)
                        endTime = moment(this.dataTime[1]).format(this.vformat)
                    } else {
                        this.$message.error('请选择时间范围')
                        return
                    }
                    params.startTime = startTime
                    params.endTime = endTime
                    params.timeType = 6
                    params.timeType = timeType

                } else {
                    if (this.dataTime === null || this.dataTime === '') {
                        this.$message.error('请选择时间范围')
                        return
                    }
                    time = moment(this.dataTime[0]).format(this.vformat)
                    timeTwo = moment(this.dataTime[1]).format(this.vformat)
                    params.time = time
                    params.timeTow = timeTwo
                    params.timeType = timeType
                }
            }
            this.loading = true
            let res = await this.$http.post('/merchantOrderHistory/saleAnalyse', params)
            if (res.data.code == 200) {
                //payPrice
                this.initPieChart(res.data.data.summary.payPrice)
                this.tableData = res.data.data.list
                this.loading = false
            } else {
                this.loading = false
            }
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] = sums[index].toFixed(2);
                    sums[index] += ' 元';
                } else {
                    sums[index] = '--';
                }
            });

            return sums;
        }

    }
};
</script>


<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    background-color: #fff;
    padding: 20px;
}


.search-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 20px;



    .type-box {
        display: flex;
        align-items: center;
        margin-right: 20px;
        justify-content: flex-start;

        span {
            padding: 0 10px;
            cursor: pointer;
            color: #333;
            border: 1px solid #cecece;
            font-size: 14px;
        }

        .active {
            color: #f59a23;
            border: 1px solid #f59a23;
        }
    }
}


/deep/ .el-radio-button__inner:hover {
    color: #f59a23;
}
</style>